import { buildQueryString } from '../helpers/Utils';

export default class Groups {
  constructor(api) {
    this.api = api;
  }

  selectData() {
    return this.api.fetchJson('/api/groups/selectdata');
  }

  list(query) {
    query = query || {};
    const queryString = buildQueryString(query);
    return this.api.fetchJson('/api/groups/list' + queryString);
  }

  createOrUpdate(data) {
    const method = data.id ? 'PUT' : 'POST';

    return this.api.fetchJson('/api/groups', {
      method,
      body: JSON.stringify(data),
    });
  }
}
